<!--  LEFT NAV-->
<!--<div (mouseenter)="navOpen = true;" (mouseleave)="navOpen = false;" class="collage-nav"
     [ngClass]="{'collage-nav-closed': !navOpen, 'collage-nav-open': navOpen}">
  <div *ngIf="navOpen" style="flex: 1; padding: 10px;">
    <mat-label style="text-align: center">Previous Projects:</mat-label>
  </div>
  <div style="flex-basis: fit-content; cursor: pointer;" (click)="navOpen = !navOpen">
    <div style="height: 100%; position: relative;">
      <mat-icon style="position: relative; top: 50%; transform: translateY(-50%);" *ngIf="!navOpen">chevron_right
      </mat-icon>
      <mat-icon style="position: relative; top: 50%; transform: translateY(-50%);" *ngIf="navOpen">chevron_left
      </mat-icon>
    </div>
  </div>
</div>-->
<app-collage-nav (filterChange)="onFilterChange($event)" style="position: absolute; z-index: 1000;" data-cy="collage-nav-component"></app-collage-nav>
<div #main class="collage-main" data-cy="collage-main-container">
  <div style="flex-basis: 30px; display: flex;" data-cy="collage-header">
    <div style="margin-top: 2px; margin-bottom: 2px;" data-cy="collage-name-section">
          <span
            style="color: var(--tdo-primary); margin-top: 3px; margin-left: 8px; margin-right: 8px;" data-cy="collage-name-label">Collage Name:</span>
      <input class="collage-standard-input" style="width: 400px; margin-right: 8px;" data-cy="collage-name-input"/>
      <span style="color: var(--tdo-primary); margin-top: 3px; margin-right: 16px;" data-cy="collage-patient-label">Patient:</span>
      <span data-cy="collage-patient-name">{{patientName}}</span>
    </div>
  </div>
  <div style="flex: 1 0 0; overflow: hidden;" data-cy="collage-content">
    <div id="tab-nav" data-cy="collage-tab-nav">
      <div matTooltip="Add new page" (click)="onNewTabClick($event)"
           style="position: absolute; right: 34px; color: var(--tdo-secondary); cursor: pointer; margin-top: 12px; user-select: none;" data-cy="collage-add-page-button">
        <mat-icon data-cy="collage-add-page-icon">add_circle_outline</mat-icon>
      </div>
      <div style="flex: 1; overflow: hidden;" data-cy="collage-tabs-container">
        <div style="width: 100%; height: 100%; overflow: hidden;" data-cy="collage-tabs-wrapper">
          <mat-tab-group animationDuration="0ms" mat-align-tabs="start" [selectedIndex]="getSelectedIndex()"
                         (selectedTabChange)="onTabChange($event)" data-cy="collage-tab-group">
            <ng-container *ngFor="let tab of tabs" (click)="selectTab(tab)">
              <mat-tab data-cy="collage-tab">
                <ng-template mat-tab-label>
                  <div class="col" style="margin-left: 20px;" data-cy="collage-tab-name">{{tab.tabName}}</div>
                  <button style="color:black; position: relative;" mat-icon-button (click)="removeTab($event, tab)" data-cy="collage-tab-close-button">
                    <mat-icon style="position: relative; right: 0;" data-cy="collage-tab-close-icon">close</mat-icon>
                  </button>
                </ng-template>
                <div style="display: flex; height: 100%; max-height: 100%; width: 100%; max-width: 100%; overflow: hidden;" data-cy="collage-tab-content">
                  <div style="flex: 1; overflow: auto; max-height: calc(100vh - 200px); max-width: calc(100vw - 30px);" data-cy="collage-tab-scroll-area">
                    <div #boundary style="flex: 1;" id="boundary" (click)="clearSelected()"
                         [style.background-color]="color"
                         ondrop="drop(event)" ondragover="allowDrop(event)" [ngClass]="changeSize()" data-cy="collage-canvas">
                      <div class="resize-drag editableText" *ngFor="let text of tab.listOfTextObjects, let i = index"
                           oncontextmenu="return false;"
                           (contextmenu)="onRightClickTextContextEvent($event, text, boundary)"
                           [innerHTML]="text.value" appDrawAfterRender (drawReady)="onCustomTextRender(text, boundary)"
                           style="width: auto" cdkDrag cdkDragBoundary=".boundary" data-cy="collage-text-item">
                      </div>
                      <div *ngFor="let image of tab.listOfImages, let i = index" oncontextmenu="return false;" data-cy="collage-image-wrapper">
                        <app-tdo-draggable-image [left]="image.left"
                                                 [top]="image.top"
                                                 [index]="i"
                                                 [ngStyle]="{'z-index': i}"
                                                 [style.transform.rotate]="image.rotation"
                                                 [id]="'image' + i"
                                                 [imageSource]="image.documentURL"
                                                 class="resize-drag"
                                                 (contextmenu)="onRightClickImageContextEvent($event, image, target)" data-cy="collage-image-item">
                        </app-tdo-draggable-image>
                        <i class="rotation-handle material-icons-outlined" data-cy="collage-image-rotate-handle">rotate_right</i>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </ng-container>
          </mat-tab-group>
        </div>
        <div *ngIf="preview === true" style="height: 100%;" id="previewImage" class="col-lg-12" data-cy="collage-preview-container">
                    <img src={{capturedImage}} data-cy="collage-preview-image">
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2" style="flex-basis: 20px;" data-cy="collage-footer">
    <div class="col-12 d-flex justify-content-end" data-cy="collage-controls">
                <!--<input
                  style="display: none"
                  type="file"
                  #fileInput multiple>-->
                <!--<button *ngIf="preview === false" mat-button class="tdo-button tdo-save" style="width:125px; margin-left: 10px;" (click)="fileInput.click()">
                  Add Images
                </button>-->

      <button mat-button class="tdo-button tdo-save" style="width:125px; margin-left: 10px;"
              (click)="openTemplate()" data-cy="collage-layout-button">
        Layout
      </button>
      <button mat-button class="tdo-button tdo-save" style="width:125px; margin-left: 10px;"
              (click)="addTextItem()" data-cy="collage-add-text-button">
        Add Text
      </button>
      <small
        style="margin-top: 8px; margin-left: 10px; text-align: center; color: var(--tdo-secondary); font-weight: bold" data-cy="collage-instructions">Click
        to select: Pull from corner to enlarge, or edges to crop. Mousewheel to zoom.</small>
      <div style="flex: 1;"></div>
      <div style="position: relative; top: -8px; display: flex;" data-cy="collage-options">
                <!--<button mat-button class="tdox-btn tdox-btn-primary">
                  <app-tdo-color-picker></app-tdo-color-picker>
                </button>-->
      <app-tdo-color-picker labelColor="#000000" color="#000000" (colorChange)="onColorChange($event)" [pickerPosition]="'top'" data-cy="collage-color-picker"></app-tdo-color-picker>
<!--        <mat-form-field style="width: 200px; margin-right: 15px; text-align: center; color: var(&#45;&#45;tdo-secondary);">-->
<!--          <mat-select [(ngModel)]="color" [(value)]="color" class="color">-->
<!--            <mat-option *ngFor="let option of backgroundPresets" [value]="option">-->
<!--              Background: {{option}}</mat-option>-->
<!--          </mat-select>-->
<!--        </mat-form-field>-->
        <mat-form-field style="width: 200px; margin-right: 15px; text-align: center; color: var(--tdo-secondary);" data-cy="collage-size-field">
          <mat-select [(ngModel)]="size" [(value)]="size" class="size" data-cy="collage-size-select">
            <mat-option *ngFor="let option of backgroundSize" [value]="option?.id" data-cy="collage-size-option">{{option?.id}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div style="margin-top: 8px; margin-right: 8px; display: flex;" data-cy="collage-publish-container">

          <button mat-button class="tdo-button tdo-save" (click)="save()" style="width:125px" data-cy="collage-publish-button">
            Publish
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-collage-publish-drawer #publishDrawer style="position: absolute; bottom: 0; z-index: 3000;"
                            [parentContainer]="main"
                            [screenshotData]="screenshotData" data-cy="collage-publish-drawer"></app-collage-publish-drawer>

<ng-template #imageContextMenu let-data>
  <section class="image-context-menu" data-cy="collage-image-context-menu">
    <!--    <div *ngIf="isNotRootNode(data)" (click)="onPatientPaste(data)" class="item">Paste</div>-->
  </section>
</ng-template>
